// export const calculateAge = (birthdate) => {
//     const birthDate = new Date(birthdate);
//     const today = new Date();
//     let age = today.getFullYear() - birthDate.getFullYear();
//     const monthDiff = today.getMonth() - birthDate.getMonth();
  
//     if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
//       age--;
//     }
  
//     return age;
// };

export const calculateAge = (birthdate) => {
  // Handle different date formats (DD-MM-YYYY or YYYY-MM-DD)
  const parts = birthdate?.split('-');
  
  // Create date object based on format
  let birthDate;
  if (parts[0].length === 4) {
    // YYYY-MM-DD format
    birthDate = new Date(birthdate);
  } else {
    // DD-MM-YYYY format
    birthDate = new Date(parts[2], parts[1] - 1, parts[0]);
  }
  
  // Check if date is valid
  if (isNaN(birthDate.getTime())) {
    return "Invalid date";
  }
  
  const today = new Date();
  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();
  
  if (months < 0 || (months === 0 && today.getDate() < birthDate.getDate())) {
    years--;
    months += 12;
  }
  
  return years > 0 ? `${years} years` : `${months} months`;
};
  